export default __webpack_public_path__ + "static/media/thsarabunnew_bold-webfont.55e0459f.woff";